// https://lincolnprofilev9.cms.dealer.com/lincoln-corsair-PHEV.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				logic: {
					widgetClasses: 'tagging-view-inventory-vehicle-specific'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'bluecruise:content:view inventory',
							onclickLinkName: 'bluecruise:content:action'
						}
					}
				})
			},
			// above rule needs to be above below as it is more specific
			// if you reverse the order the above rule will never get matched
			// due to how the logic is tested
			{
				logic: {
					widgetClasses: 'tagging-view-inventory'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'bluecruise:content:view inventory',
							onclickLinkName: 'bluecruise:content:action'
						}
					}
				})
			},
			{
				logic: {
					widgetClasses: 'tagging-learn-more-bluecruise'
				},
				payload: () => ({
					directCall: 'referral-exit',
					payload: {
						event: {
							action: 'brand referral'
						},
						onclick: {
							onclick: 'referral:ln:bluecruise',
							referredTo: 'ln:bluecruise',
							onclickLinkName: 'referral:exit'
						}
					}
				})
			},
			{
				logic: {
					widgetClasses: 'tagging-learn-more-connected-services'
				},
				payload: () => ({
					directCall: 'referral-exit',
					payload: {
						event: {
							action: 'brand referral'
						},
						onclick: {
							onclick: 'referral:ln:connected services',
							referredTo: 'ln:connected services',
							onclickLinkName: 'referral:exit'
						}
					}
				})
			},
			{
				logic: {
					widgetClasses: 'tagging-schedule-a-test-drive'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'bluecruise:content:schedule test drive',
							onclickLinkName: 'bluecruise:content:action'
						}
					}
				})
			}
		]
	}
};
